export default "__VITE_ASSET__BKDvZbFT__"